import Rollbar from 'rollbar';

const rollbar = new Rollbar({
  accessToken: typeof process !== 'undefined' && process.env ? process.env.ROLLABAR_ACCESSTOKEN : '',
  environment: typeof process !== 'undefined' && process.env ? process.env.REACT_APP_ROLLBAR_ENVIRONMENT : '',
  captureUncaught: true,
  captureUnhandledRejections: true,
});

export default rollbar;
